import React, { useState } from 'react';
import { Button, Divider, Form, Modal, message } from 'antd';
import { useHistory } from 'react-router-dom';
import DefaultValues from './molecules/DefaultValues';
import DefaultCompanyValues from './molecules/DefaultCompanyValues';
import FieldsVisibility from './molecules/FieldsVisibility';
import FormItemSubmit from './atoms/FormItemSubmit';
import {
  findSettings,
  updateSettings,
} from '../../../services/repository/settingRepository';
import { isEqualObjects } from '../../../services/util';
import { filterObjectByKey } from '../../../services/util/object/object';

function Settings() {
  const settings = findSettings();
  const { defaultValues, defaultCompanyValues, fieldsVisibility } = settings;
  const [defaultValuesState, setDefaultValues] = useState(defaultValues);
  const [defaultCompanyValuesState, setDefaultCompanyValues] =
    useState(defaultCompanyValues);
  const [fieldsVisibilityState, setFieldsVisibility] =
    useState(fieldsVisibility);
  const history = useHistory();

  const changedSettings = {
    defaultValues: defaultValuesState,
    defaultCompanyValues: defaultCompanyValuesState,
    fieldsVisibility: fieldsVisibilityState,
  };

  const isSettingsChanged = !isEqualObjects(changedSettings, settings);

  const onChangeSettings = (
    changeStateMethod,
    currentState,
    key,
    valueType,
    value
  ) =>
    changeStateMethod({
      ...currentState,
      [key]: {
        ...currentState[key],
        valueType,
        value,
      },
    });

  const onSaveClick = () => {
    updateSettings(changedSettings);
    message.success('Configurações salvas com sucesso');
    history.goBack();
  };

  const onCancelClick = () => {
    if (isSettingsChanged) {
      Modal.confirm({
        cancelText: 'Não',
        okText: 'Sim',
        content: 'Você tem certeza que deseja cancelar?',
        onOk: () => history.goBack(),
      });
    } else {
      history.goBack();
    }
  };

  const cltReKeys = ['transporte', 'salario', 'beneficios', 'ajudaCusto'];
  const cltReDefaultValues = filterObjectByKey(defaultValuesState, cltReKeys);

  return (
    <Form layout="vertical">
      <p>
        <b>CLT/RE</b>
      </p>
      <DefaultValues
        settings={cltReDefaultValues}
        onChange={(...args) =>
          onChangeSettings(setDefaultValues, defaultValuesState, ...args)
        }
      />

      <Divider style={{ marginTop: '0px' }} />
      <DefaultCompanyValues
        settings={defaultCompanyValuesState}
        onChange={(...args) =>
          onChangeSettings(
            setDefaultCompanyValues,
            defaultCompanyValuesState,
            ...args
          )
        }
      />
      <Divider style={{ marginTop: '0px' }} />
      <FieldsVisibility
        settings={fieldsVisibilityState}
        onChange={(...args) =>
          onChangeSettings(setFieldsVisibility, fieldsVisibilityState, ...args)
        }
      />
      <FormItemSubmit>
        <Button htmlType="button" onClick={onCancelClick}>
          Cancelar
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          onClick={onSaveClick}
          disabled={!isSettingsChanged}
        >
          Salvar Configurações
        </Button>
      </FormItemSubmit>
    </Form>
  );
}

export default Settings;
